$(function(){
  $('.js-auto-modal').modal('show');
  $('[data-toggle="tooltip"]').tooltip();
});
